/* eslint-disable no-param-reassign */
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

import parkedCallsAPI from 'src/api/parkedCalls';

const getParkedCalls = createAsyncThunk('parkedCallsPage/get', async (page = 1) => parkedCallsAPI.getParkedCalls(page));

const deleteParkedCalls = createAsyncThunk('parkedCallsPage/delete', async id => parkedCallsAPI.deleteParkedCalls(id));

const Slice = createSlice({
  name: 'parkedCallsPage',
  initialState: {
    status: 'loading',
    message: '',
    data: [],
  },
  reducers: {},
  extraReducers: {
    [getParkedCalls.pending]: (state, action) => {
      state.status = 'loading';
    },
    [getParkedCalls.fulfilled]: (state, action) => {
      const { status, message, data } = action.payload;
      state.status = status;
      state.message = message;
      state.data = data.items;
    },
    [getParkedCalls.rejected]: () => {},

    [deleteParkedCalls.pending]: (state, action) => {
      state.status = 'loading';
    },
    [deleteParkedCalls.fulfilled]: (state, action) => {
      const { status, message } = action.payload;
      state.status = status;
      state.message = message;
      getParkedCalls();
    },
  },
});

export { getParkedCalls, deleteParkedCalls };
export default Slice.reducer;
